import React, { useCallback, useEffect, useState } from 'react';

import { Layout } from 'layouts';
import { RedeemMerchantTermsContainer } from 'components/Redeem';
import { PageTitle } from 'components/misc';
import { useAnalytics } from 'hooks';

import { getBasePathname } from 'utilities/huggg';
import dict from 'config/dictionary';
import HistoryService from 'services/HistoryService';

const history = new HistoryService();

export const ScreensMerchantTerms = () => {
  const [url, setUrl] = useState();
  const [huggg, setHuggg] = useState(null);
  const analytics = useAnalytics();
  const backAction = useCallback(() => url, [url]);
  const onContentLoaded = useCallback(
    (_content, huggg) => {
      setHuggg(prevState => ({ ...prevState, ...huggg }));
      if (
        history.getPreviousPathname() !== '/' &&
        history.getPreviousPathname() !== history.location.pathname
      ) {
        setUrl(history.getPreviousPathname());
      } else {
        setUrl(getBasePathname(huggg));
      }
    },
    []
  );

  useEffect(() => {
    if (huggg) {
      huggg.isSuperhuggg
        ? analytics.screenViewedSuperhugggMerchantTerms()
        : analytics.screenViewedHugggMerchantTerms();
    }
  }, [analytics, huggg]);

  return (
    <Layout backAction={backAction}>
      <PageTitle title={dict.pageTitle.merchantTerms} />

      <div data-test-id="screen-merchant-terms" className="container">
        <div className="container">
          <RedeemMerchantTermsContainer onContentLoaded={onContentLoaded} />
        </div>
      </div>
    </Layout>
  );
};

export default ScreensMerchantTerms;
